export class WithError<A> {
  value: A
  hasError: boolean
  error: unknown
  errorMessage: string

  constructor(
    value: A,
    hasError = false,
    error: unknown = null,
    errorMessage: string = null,
  ) {
    this.value = value
    this.hasError = hasError
    this.error = error
    this.errorMessage = errorMessage
  }
}
